import React from 'react';
import ChartComponent from './ChartComponent';
import { LineChartData } from '../../types';
import { useTheme, useMediaQuery } from '@mui/material';

// Interface para as propriedades do componente
interface LineChartComponentProps {
  data: LineChartData;
  title: string;
  loading?: boolean;
  error?: string | null;
  height?: number | string;
  color?: string;
  backgroundColor?: string;
  fill?: boolean;
}

const LineChartComponent: React.FC<LineChartComponentProps> = ({
  data,
  title,
  loading = false,
  error = null,
  height = 350,
  color = '#3f88c5',
  backgroundColor = 'rgba(63, 136, 197, 0.2)',
  fill = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Formatar os dados para o formato esperado pelo ChartComponent
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: data.label || title,
        data: data.values,
        fill: fill,
        backgroundColor: backgroundColor,
        borderColor: color,
        borderWidth: 2,
        tension: 0.4,
        pointRadius: isMobile ? 3 : 4,
      },
    ],
  };

  // Opções do gráfico
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        labels: {
          boxWidth: isMobile ? 12 : 15,
          font: {
            size: isMobile ? 12 : 14
          }
        }
      },
      title: {
        display: false,
      },
      // Adicionar informações de valor no tooltip
      tooltip: {
        callbacks: {
          label: function(context: any) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += `R$ ${context.parsed.y.toLocaleString('pt-BR')}`;
            }
            return label;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value: any) {
            return `R$ ${value.toLocaleString('pt-BR')}`;
          },
          font: {
            size: isMobile ? 10 : 12
          }
        }
      },
      x: {
        ticks: {
          font: {
            size: isMobile ? 10 : 12
          }
        }
      }
    },
  };

  return (
    <ChartComponent
      chartType="line"
      chartData={chartData}
      chartOptions={chartOptions}
      title={title}
      loading={loading}
      error={error}
      height={height}
    />
  );
};

export default LineChartComponent; 